export const Wrapper = 'flex w-full flex-col flex-wrap py-4 sm:flex-row md:py-6'

export const AddressesWrapper =
  'flex w-full shrink-0 flex-col pb-6 sm:flex-row xl:w-1/2 xl:pb-0'

export const ShippingAndPaymentWrapper =
  'flex w-full shrink-0 flex-col sm:flex-row xl:w-1/2'

export const ShippingAddressWrapper =
  'flex w-full shrink-0 flex-col pb-6 sm:w-1/2 sm:pb-0'

export const BillingAddressWrapper = 'flex w-full shrink-0 flex-col sm:w-1/2'

export const InfoNameSpacing = 'pb-2'

export const PaymentInfoWrapper =
  'flex w-full shrink-0 flex-col pb-6 sm:w-1/2 sm:pb-0'

export const ShippingMethodInfoWrapper =
  'flex w-full shrink-0 flex-col sm:w-1/2'
